// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* n-drip loading spinner: rotate the three-quarter ring 360° every 800ms
   (the Figma frames step 90° per 200ms; smart-animate makes that a smooth
   continuous rotation). Color comes from --color-grey-71 via currentColor. */
@keyframes ndrip-spinner-rotate {
  to {
    transform: rotate(360deg);
  }
}

.ndrip-spinner {
  display: inline-flex;
  color: var(--color-grey-71);
  color: var(--color-grey-71);
  line-height: 0;
}

.ndrip-spinner > svg {
  display: block;
  animation: 0.8s linear infinite ndrip-spinner-rotate;
}

@media (prefers-reduced-motion: reduce) {
  .ndrip-spinner > svg {
    animation-duration: 2.4s;
  }
}
`, "",{"version":3,"sources":["webpack://./app/components/general/Spinner.css"],"names":[],"mappings":"AAAA;;6EAE6E;AAC7E;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* n-drip loading spinner: rotate the three-quarter ring 360° every 800ms\n   (the Figma frames step 90° per 200ms; smart-animate makes that a smooth\n   continuous rotation). Color comes from --color-grey-71 via currentColor. */\n@keyframes ndrip-spinner-rotate {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.ndrip-spinner {\n  display: inline-flex;\n  color: var(--color-grey-71);\n  color: var(--color-grey-71);\n  line-height: 0;\n}\n\n.ndrip-spinner > svg {\n  display: block;\n  animation: 0.8s linear infinite ndrip-spinner-rotate;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ndrip-spinner > svg {\n    animation-duration: 2.4s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
